module.exports = __webpack_public_path__ + "static/CleanAir-Mobile-Header-1080x550-Curve-DataHub-2x-fd5e9bc88a01551e23fb8654b7e1e914.png";